import React, { Component } from 'react';
import { ModalBody, ModalHeader, ModalFooter, Button, Row, Col, Label } from 'reactstrap';

class PreviewModal extends Component {
    render() {
        return (
            <div>
                <ModalHeader>Preview Whitelabel</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <div>Rubix</div>
                            <div>
                                <PrimaryButtons colorCode={'#407ebc'} buttonType={'primary'} />
                                <PrimaryButtons colorCode={'#407ebc'} buttonType={'secondary'} />
                                <Checkbox colorCode={'#407ebc'} />
                                <Icons colorCode={'#407ebc'} />
                            </div>
                        </Col>
                        <Col>
                            <div>Client</div>
                            <div>
                                <PrimaryButtons colorCode={this.props.corporateColor} buttonType={'primary'} />
                                <PrimaryButtons colorCode={this.props.corporateColor} buttonType={'secondary'} />
                                <Checkbox colorCode={this.props.corporateColor} />
                                <Icons colorCode={this.props.corporateColor} />
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.props.handleToggle}>Ok</Button>
                </ModalFooter>
            </div>
        )
    }
}
export default PreviewModal;

const PrimaryButtons = (props) => {
    return <div className='preview-component'>
        <div>
            <Label>{(props.buttonType === 'primary') ? 'Primary' : 'Secondary'}</Label>
        </div>
        <Button className={(props.buttonType === 'primary') ? "client-buttons" : "client-buttons-secondary"} style={{ '--primaryColor': props.colorCode }}>Buttons</Button>
    </div>
}

const Checkbox = (props) => {
    return <div className="preview-component custom-control custom-checkbox">
        <div style={{ marginLeft: '-11%' }}>Checkbox</div>
        <div>
            <span>
                <input
                    type="checkbox"
                    className="custom-control-input m-0"
                    name='checkboxTrue'
                    id='checkboxTrue'
                    readOnly
                    checked={false}
                />
                <label style={{ '--primaryColor': props.colorCode, top: '0.29rem' }} className="custom-control-label mb-1" title='checkboxTrue' htmlFor='checkboxTrue'></label>
            </span>
            <span>
                <input
                    type="checkbox"
                    className="custom-control-input m-0"
                    name='checkboxTrue'
                    id='checkboxTrue'
                    readOnly
                    checked
                />
                <label style={{ '--primaryColor': props.colorCode, top: '0.27rem', marginLeft: '19%' }} className="custom-control-label mb-1" title='checkboxTrue' htmlFor='checkboxTrue'></label>
            </span>
        </div>
    </div>
}

const Icons = (props) => {
    return <div className="preview-component">
        <div style={{ marginLeft: '2%' }}>Icons</div>
        <div style={{marginTop: '2%'}}>
            <span><i className="icon-user icon-color" style={{ '--primaryColor': props.colorCode }} /></span>
            <span style={{ marginLeft: '10%' }}><i className="icon-search icon-color" style={{ '--primaryColor': props.colorCode }} /></span>
        </div>
    </div>
}